let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("kfr6k")]).then(() => parcelRequire('2fsbx'));